export default __webpack_public_path__ + "static/media/mirChar.4ea5b7f8.jfif";